// extracted by mini-css-extract-plugin
export default {"discontinueReason":"PatientPrescriptionAdjustMedicationPopup_discontinueReason__YB0Kn"};